"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playNextPreviousMedia = exports["default"] = void 0;

var playNextPreviousMedia = function playNextPreviousMedia(_ref) {
  var data = _ref.medias.data,
      showPlayer = _ref.showPlayer,
      updateLastPlayed = _ref.updateLastPlayed,
      setActiveMedia = _ref.setActiveMedia,
      nextOrPrevious = _ref.nextOrPrevious,
      mediaId = _ref.mediaId;
  var currentMediaIndex = data.findIndex(function (media) {
    return media.mediaId === mediaId;
  });
  var nextMedia = {};

  if (nextOrPrevious === "next") {
    if (currentMediaIndex < data.length - 1) {
      nextMedia = data[currentMediaIndex + 1];
    } else {
      nextMedia = data[0];
    }
  }

  if (nextOrPrevious === "previous") {
    if (currentMediaIndex > 0) {
      nextMedia = data[currentMediaIndex - 1];
    } else {
      nextMedia = data[data.length - 1];
    }
  }

  if (!nextMedia) return;
  showPlayer(nextMedia.mediaId);
  updateLastPlayed(nextMedia.mediaId);
  setActiveMedia(nextMedia.mediaId);
};

exports.playNextPreviousMedia = playNextPreviousMedia;
var _default = playNextPreviousMedia;
exports["default"] = _default;